import React from "react";
import { Spinner } from "react-bootstrap";
import { formatReportDate } from "../../utils/DataConversion";

export default function UpdateText({ reportDate }: { reportDate: string }) {
  return (
    <div className="mb-3 p-2">
      <div>
        Below results are as of{" "}
        {reportDate.length ? (
          <b>{formatReportDate(reportDate)}</b>
        ) : (
          <Spinner animation="grow" size="sm" />
        )}
        . Dashboard updated <b>by 5 p.m.</b> Monday through Friday.
      </div>
      <p>
        New positive cases, deaths and tests have occurred over a range of dates
        but were reported to the state Department of Health in the last 24
        hours.
      </p>
    </div>
  );
}
